import { connect } from 'react-redux';
import { searchSelectors, currentUserSelectors, contactSelectors } from '@lifesize/nucleus';
import actions from 'actions/ScheduleModal';
import { loadContactManually } from 'actions/Contact';
import { SCHEDULE_FORM } from 'constants/ScheduleModal';
import oneTimeMeetingFeatureSelector from 'selectors/contact';
import { reset } from 'redux-form';
import ScheduleSearch from 'components/ScheduleModal/ScheduleSearch/ScheduleSearch';
import _get from 'lodash/get';

const getContactUuid = (contact) => {
  // TEMP
  // It seems like the myInfo selector doesn't return "uuid" (it returns "id") so we have to do this.
  // I'm writing a ticket to take care of this in CNUC.
  return _get(contact, 'uuid') || _get(contact, 'id');
};

const mapDispatchToProps = (dispatch) => ({
  handleSelectContact: (contact) => {
    dispatch(loadContactManually(contact));
    if (contact.isCreateOneTime) {
      dispatch(actions.scheduleOneTimeMeeting());
    } else {
      dispatch(actions.selectContactForSchedule(getContactUuid(contact)));
    }

    dispatch(reset(SCHEDULE_FORM));
    dispatch(actions.setScheduleFormFocus(false));
  },
  handleSetIsFocused: (isFocused) => dispatch(actions.setScheduleFormFocus(isFocused)),
  clearSelectedSchedule: () => {
    dispatch(reset(SCHEDULE_FORM));
    dispatch(actions.selectContactForSchedule(null));
  },
  handleEnter: (selectedContact) => {
    dispatch(actions.selectContactForSchedule(getContactUuid(selectedContact)));
    dispatch(reset(SCHEDULE_FORM));
    dispatch(actions.setScheduleFormFocus(false));
  }
});

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.scheduleSearch.values.scheduleSearch');
  const isFocused = _get(state, 'app.scheduleModal.isFocused');
  const currentUser = currentUserSelectors.myInfo(state);
  const searchResults = searchString
    ? searchSelectors.searchRoomSystemsAndMeetings(state)
    : contactSelectors.favoritesSelector(state).filter((result) => result.isMeeting || result.isRoomSystem);

  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const showOneTimeMeetings = oneTimeMeetingFeatureSelector(state);

  let selectedContact;
  if (selectionIndex === 0) {
    selectedContact = currentUser;
  } else {
    selectedContact =
      _get(searchResults, `[${selectionIndex - 1}].contact`) || _get(searchResults, `[${selectionIndex - 1}]`);
  }

  return {
    // Adjust maxItems if showOneTimeMeetings disabled for a user.
    maxItems: Math.min(showOneTimeMeetings ? searchResults.length + 2 : searchResults.length + 1, 5),
    currentUser,
    searchString,
    isFocused,
    selectedContact,
    searchResults,
    searchResultCount: searchResults.length + 1,
    showOneTimeMeetings
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleSearch);
